import { applyMiddleware, compose, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import thunk from "redux-thunk";

import rootReducer from "./reducers";

export const history = createBrowserHistory();

history.listen(_ => {
  window.scrollTo(0, 0);
});

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const historyRouterMiddleware = routerMiddleware(history);

export const store = createStore(rootReducer(history), {}, composeEnhancer(applyMiddleware(historyRouterMiddleware, thunk)));
